import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      toast.error("Nowe hasło musi mieć co najmniej 8 znaków");
      return;
    }
    if (newPassword !== newPassword2) {
      toast.error("Nowe hasła się nie zgadzają");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: currentPassword, new_password: newPassword });
      toast.success("Hasło zmienione");
      setCurrentPassword(""); setNewPassword(""); setNewPassword2("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Błąd zmiany hasła");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="change-password" className="max-w-md border-t border-[#E5E0D8] pt-8 mt-8 space-y-5">
      <div>
        <h3 className="font-display text-lg text-[#2B2B2B] mb-2">Zmiana hasła</h3>
        <p className="text-sm text-[#5C6670]">Dotyczy konta, na które jesteś zalogowana/y.</p>
      </div>
      <div>
        <label className="text-overline block mb-2">Obecne hasło</label>
        <input
          type="password" required value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
          data-testid="current-password"
          className="w-full bg-transparent border-b border-[#E5E0D8] py-2.5 focus:outline-none focus:border-[#8A9A86] text-[#2B2B2B]"
        />
      </div>
      <div>
        <label className="text-overline block mb-2">Nowe hasło</label>
        <input
          type="password" required minLength={8} value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
          data-testid="new-password"
          className="w-full bg-transparent border-b border-[#E5E0D8] py-2.5 focus:outline-none focus:border-[#8A9A86] text-[#2B2B2B]"
        />
      </div>
      <div>
        <label className="text-overline block mb-2">Powtórz nowe hasło</label>
        <input
          type="password" required minLength={8} value={newPassword2} onChange={(e) => setNewPassword2(e.target.value)}
          data-testid="new-password-2"
          className="w-full bg-transparent border-b border-[#E5E0D8] py-2.5 focus:outline-none focus:border-[#8A9A86] text-[#2B2B2B]"
        />
      </div>
      <button
        type="submit" disabled={saving} data-testid="change-password-save"
        className="px-6 py-2.5 rounded-xl bg-[#2B2B2B] text-white text-sm disabled:opacity-50"
      >
        {saving ? "Zapisywanie…" : "Zmień hasło"}
      </button>
    </form>
  );
}
